import { useState } from "react";
import {
  DialogActions,
  DialogTitle,
  Grid,
  Card,
  Container,
} from "@material-ui/core";
import TabsErp from "../../../../components/tabs/TabsErp";
import Chip from "../../../../components/basics/Chip";
import Btn from "../../../../components/buttons/Btn";

//import TabReajuste from "./TabReajuste";
import TabAbatimento from "./TabAbatimento";
import TabAvulso from "./TabAvulso";
import TabDespesas from "./TabDespesas";
import {
  CustomDialog,
  DialogContentStyled,
  Header,
  StyledDialog,
} from "../../../../patterns/modals/modallog/styles/styles";

const tabHeaders = [
  // { SERÁ USADO NA PRÓXIMA SPRINT
  //   label: "Reajuste",
  // },
  {
    label: "Abatimentos",
  },
  {
    label: "Serviços Avulsos",
  },
  {
    label: "Despesas Reembolsáveis",
  },
];

const ModalEditHistoric = ({
  open,
  content,
  setContent,
  setOpen,
  setCrRows,
}) => {
  const tabContents = [
    // <TabReajuste edit={false} content={content.reajustes} setContent={setContent} />, SERÁ USADO PRÓXIMA SPRINT
    <TabAbatimento
      content={content.abatimentos}
      setContent={setContent}
      setCrRows={setCrRows}
    />,
    <TabAvulso
      content={content.servicosAvulso}
      setContent={setContent}
      setCrRows={setCrRows}
    />,
    <TabDespesas
      content={content.despesas}
      setContent={setContent}
      setCrRows={setCrRows}
    />,
  ];

  const [tabIndex, setTabIndex] = useState(0);

  const handleCloseModal = () => {
    setOpen(false);
  };

  return (
    <CustomDialog
      open={open}
      maxWidth="md"
      aria-labelledby="dialog-title"
      fullWidth={true}
    >
      <StyledDialog>
        <DialogTitle id="dialog-title">
          <Header>
            <Grid container align="center" justifyContent="center">
              <Chip
                bgcolor="primary"
                textcolor="white"
                label="REGISTROS DE ALTERAÇÕES"
              />
            </Grid>
          </Header>
        </DialogTitle>
        <DialogContentStyled>
          <Container maxWidth="xl">
            <Card>
              <TabsErp
                headers={tabHeaders}
                children={tabContents}
                tabIndex={tabIndex}
                onChange={(event, value) => {
                  if (Number.isInteger(value)) setTabIndex(value);
                }}
              />
            </Card>
          </Container>
        </DialogContentStyled>
        <DialogActions>
          <Btn label="Cancelar" bgcolor="tertiary" onClick={handleCloseModal} />
        </DialogActions>
      </StyledDialog>
    </CustomDialog>
  );
};

export default ModalEditHistoric;
